import script from "./PrivacyPolicyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyPolicyPage.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=d0b2f66e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0b2f66e"]])

export default __exports__